export enum Buy {
  money = 20, // - забирает бабки
  productNFT = 21, // - забирает нфт - пока константой стоимость минта нфт(1 бнб)
}
